// extracted by mini-css-extract-plugin
export var conversationListItem = "_y9-2";
export var fullBleedList = "_y9-3";
export var messageText = "_y9-1";
export var previewText = "_y9-0";